<div [ngClass]="isCurrentTab == tabs.SubCategory ? 'tab-pane fade show active' : 'tab-pane fade'" id="category-tab-pane" role="tabpanel" aria-labelledby="category-tab" tabindex="0">
  <div *ngIf="showForm" [formGroup]="subCategoryForm">
    <div class="content-box">
       <div class="row">
         <div class="col-sm-12 col-md-3">
           <div class="mb-4">
               <span class="black-text fs-14 mb-1">Analytics Toolkit Name</span>
               <input type="text" placeholder="Unique name in Deesha" [required]="true" formControlName="subCategoryName" class="form-control"
                [class.is-invalid]="subCategoryForm.controls['subCategoryName'].invalid && subCategoryForm.controls['subCategoryName'].touched"/>
                <div *ngIf="(subCategoryForm.controls['subCategoryName'].invalid && subCategoryForm.controls['subCategoryName'].touched) || subCategoryForm.controls['subCategoryName'].dirty">
                  <small *ngIf="subCategoryForm.controls['subCategoryName'].errors?.['required']" class="text-danger fs-13">Analytics Toolkit Name is required</small>
                </div>
           </div>
         </div>
         <div class="col-sm-12 col-md-3">
           <div class="mb-4">
               <span class="black-text fs-14 mb-1">Display Name (Optional)</span>
               <input type="text" [required]="false" formControlName="subCategoryDisplayName" class="form-control"
                [placeholder]="subCategoryForm.controls['subCategoryName'].value==''?'Display as...':(subCategoryForm.controls['subCategoryName'].value??'Display as...')"
               />
                <div *ngIf="(subCategoryForm.controls['subCategoryDisplayName'].invalid )|| subCategoryForm.controls['subCategoryDisplayName'].dirty">
                  <small *ngIf="subCategoryForm.controls['subCategoryDisplayName'].errors?.['required']" class="text-danger fs-13">Analytics Toolkit Display Name is required</small>
                </div>
           </div>
         </div>
         <div class="col-sm-12 col-md-6">
          <div class="mb-4">
              <span class="black-text fs-14 mb-1 powerbi-report-id" [class.is-invalid-report]="!isValidReport(this.subCategoryToEdit.reportId)">Report Id</span>
              <input type="text" formControlName="reportId" required="true" class="form-control" [matAutocomplete]="autoPowerBiReportList" 
                matInput placeholder="Select a Report" />
              <mat-autocomplete class="report-catalog" requireSelection="false"
                #autoPowerBiReportList="matAutocomplete" 
                (optionSelected)="generateMultiReportValues($event)"   
                (opened)="getPowerBiReports()">
                <mat-option *ngFor="let pbi1 of powerBiReports.reports" 
                style="border-bottom:1px solid #c0c0c0;margin-bottom: 1em;"
                  [value]="pbi1.id"  [class.selected]="isReportSelected(pbi1.id)">{{pbi1.name}}
                    <p><em>{{pbi1.description}}</em></p>
                </mat-option>
                
                @for ( pbi1 of powerBiReports.subFolders; track pbi1) {
                  
                    <mat-option *ngFor="let pbi2 of pbi1.reports" 
                    [matTooltip]="pbi2.id"
                    class="report-type-{{pbi2.itemType}}"
                    [class.selected]="isReportSelected(pbi2.id)" [value]="pbi2.id">{{pbi2.name}}
                      <p *ngIf="pbi2.description!=''"><em>{{pbi2.description}}</em></p>
                    </mat-option>
                    <mat-optgroup  *ngFor="let pbi2 of pbi1.subFolders" [label]="pbi2.name">
                      <mat-option *ngFor="let pbi3 of pbi2.reports" 
                      [matTooltip]="pbi3.id"
                      class="report-type-{{pbi3.itemType}}"
                      [class.selected]="isReportSelected(pbi3.id)" [value]="pbi3.id">
                        {{pbi3.name}}
                        <p *ngIf="pbi3.description!=''"><em>{{pbi3.description}}</em></p>
                      </mat-option>
                      <mat-optgroup *ngFor="let pbi3 of pbi2.subFolders" [label]="pbi3.name">
                        <mat-option *ngFor="let pbi4 of pbi3.reports" 
                          [matTooltip]="pbi4.id"
                          class="report-type-{{pbi4.itemType}}"
                          [class.selected]="isReportSelected(pbi4.id)" [value]="pbi4.id">{{pbi4.name}}
                          <p *ngIf="pbi4.description!=''"><em>{{pbi4.description}}</em></p>
                        </mat-option>
                      </mat-optgroup>
                    </mat-optgroup>
                  
                }
                
                      
              </mat-autocomplete>
          </div>
        </div>
       </div>
       <div class="divider mb-4"></div>
       <div class="row">
         <div class="col-sm-12">
           <div class="mb-2">
            <label class="black-text fs-14 mb-1">Metric</label>
            <mat-form-field (click)="checkIfMetricExists()">
              <mat-select required formControlName="metrics" multiple
              [class.is-invalid]="subCategoryForm.controls['metrics'].invalid && subCategoryForm.controls['metrics'].touched">
                <mat-select-trigger>
                  <span class="chip-list-head">Added Items:</span>
                  <span class="chip-main">
                    <span *ngFor="let metricValue of subCategoryForm.controls['metrics'].value" class="chip-list">{{metricValue.metricName}}
                      <a class="close" (click)="$event.stopPropagation();$event.preventDefault();removeMetric(metricValue)">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a>
                    </span>
                  </span>
                  @if ((subCategoryForm.controls['metrics'].value?.length || 0) > 0) {
                  <span class="chip-list count" (click)="$event.stopPropagation();$event.preventDefault(); previewPopup(subCategoryForm.controls['metrics'].value)">
                    #{{(subCategoryForm.controls['metrics'].value?.length || 0)}}
                  </span>
                  }
                </mat-select-trigger>
                @for (metric of metrics; track metric) {
                  <mat-option [value]="metric">{{metric.metricName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div *ngIf="(subCategoryForm.controls['metrics'].invalid && subCategoryForm.controls['metrics'].touched) || subCategoryForm.controls['metrics'].dirty">
              <small *ngIf="subCategoryForm.controls['metrics'].errors?.['required']" class="text-danger fs-13">Metrics is required</small>
            </div>
           </div>
         </div>
       </div>
     </div>
     <div class="sticky-btns">
       <div class="row">
         <div class="col-sm-12 text-right">
           <button type="button" class="btn theme-btn-outline px-5" (click)="closeCreateForm()">Cancel</button>
           <button type="button" class="btn theme-btn px-4 ms-3" [disabled]="subCategoryForm.invalid" (click)="createSubCategory()">{{ isEdit ? "Update" : "Create" }}</button>
         </div>
       </div>
     </div>
  </div>
   <div *ngIf="subCategories.length && !showForm" class="table-responsive tab-table data-management-table"> 
      <table aria-describedby="This table describes the sub-category information" class="table table-hover">
       <thead>
         <tr>
           <th>S.No</th>
           <th class="firstName-header">Analytics Toolkit
            <mat-icon *ngIf="sortSubcategoryNameAsc" (click)="sortSubcategoryNameAsc=false; getSubCategories('subCategoryName','asc')">arrow_upward</mat-icon>
            <mat-icon *ngIf="!sortSubcategoryNameAsc" (click)="sortSubcategoryNameAsc=true; getSubCategories('subCategoryName','desc')">arrow_downward</mat-icon>
           </th>
           <th >Metric</th>
           <th>Report ID</th>
           <th class="">Action</th>
         </tr>
       </thead>
       <tbody>
         <tr *ngFor="let subCategory of subCategories; index as i">
           <td>{{i+1}}</td>
           <td style="vertical-align: top;">
            <label class="toolkit-display" [matTooltip]="subCategory.subCategoryName!">
              <mat-icon *ngIf="subCategory.subCategoryDisplayName!=null">short_text</mat-icon>
              <span class="toolkit-display-text" *ngIf="subCategory.subCategoryDisplayName!=null">{{subCategory.subCategoryDisplayName}}</span>
              <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
            </label>
            </td>
           <td style="vertical-align: top;" >
            <div class="d-flex">
              <span *ngFor="let metric of subCategory.metrics?.slice(0,2)" class="badge fs-12">
               {{metric.metricName}}
              </span>
              <span *ngIf="subCategory.metrics.length > 0" class="badge count fs-12" (click)="previewPopup(subCategory.metrics)" >#{{subCategory.metrics.length}}</span>
            </div>
          </td>
          <td style="vertical-align: top;">
            <p class="mat-account-detail role-account-detail mb-0 powerbi-report-id" 
            [class.is-invalid-report]="!isValidReport(subCategory.reportId)"
            [matTooltip]="subCategory.reportId!">{{subCategory.reportId}}</p>
          </td>
           <td>
             <div class="d-flex">
               <div class="form-check form-switch package-switch me-1">
                 <input class="form-check-input" type="checkbox" [(ngModel)]="subCategory.status" role="switch" id="flexSwitchCheckDefault" (click)="activateDeactivateSubCategory(subCategory)">
                 <label class="form-check-label fs-12 mt-1" [ngClass]="!subCategory.status ? 'text-muted' : 'theme-text'" for="flexSwitchCheckDefault">{{subCategory.status ? "Active" : "Inactive"}}</label>
               </div>
               <div class="dropdown dropdown-actions">
                 <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                   </svg>
                 </button>
                 <ul class="dropdown-menu">
                   <li><a class="dropdown-item" (click)="editSubCategory(subCategory)"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M9.90845 4.20825C10.2668 6.50825 12.1334 8.26658 14.4501 8.49992" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M2.5 18.3333H17.5" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                   </svg>Edit</a></li>
                   <li><a class="dropdown-item" (click)="deleteSubCategory(subCategory)"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z" fill="#F24822"/>
                   </svg>Delete</a></li>
                 </ul>
               </div>
             </div>
           </td>
         </tr>
       </tbody>
     </table>
   </div>
   <mat-paginator *ngIf="subCategories?.length && !showForm" [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageNumber"
      (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100]">
   </mat-paginator>
   <div *ngIf="!subCategories.length" class="noDataFound">
    <h1>{{'No Data Found'}}</h1>
  </div>
</div>
